import auth from "../store/modules/auth";

import { log2 } from "../utils/log2";
import { distinct, filter, map } from "rxjs/operators";
import { interval } from "rxjs";
import router from "../router";
import * as _ from "lodash";

const log = log2("titleUpdater");

export const startUserPermissionValidator = () => {
    interval(500)
        .pipe(
            map((x) => router.currentRoute.path),
            distinct((x) => x),
            filter((x) => auth.state.user)
        )
        .subscribe((x) => {
            const currentRoute = router.currentRoute;
            const u = auth.state.user;
            if (u && u.role && !u.role.isRoot && _.get(currentRoute, "meta.permission")) {
                if (!u.role.permissions.find((x) => x.name === currentRoute.meta.permission)) {
                    router.push("/denied");
                }
            }
        });
};
